import { render } from "./DancePage.vue?vue&type=template&id=3083be51&scoped=true"
const script = {}

import "./DancePage.vue?vue&type=style&index=0&id=3083be51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3083be51"]])

export default __exports__